import React from 'react';
import { StaggerContainer, StaggerItem } from './AnimatedSection';
import { SpotlightCard, TiltCard } from './Animations';
import { Link } from 'react-router-dom';
import { ArrowRight, Activity } from 'lucide-react';
export interface CardProps {
  title: string;
  description?: string;
  to?: string;
  icon?: React.ReactNode;
  tag?: React.ReactNode;
}
interface CardGridProps {
  cards: CardProps[];
  columns?: 2 | 3 | 4;
}
export function CardGrid({
  cards,
  columns = 3
}: CardGridProps) {
  const gridCols = {
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4'
  };
  return <div className="w-full p-3 border border-picus-border" data-id="element-139">
      <div className="bg-picus-surface p-9" data-id="element-140">
        <StaggerContainer className={`grid gap-6 ${gridCols[columns]}`} data-id="element-141">
          {cards.map((card, idx) => <StaggerItem key={idx} data-id="element-142">
              {card.to ? <Link to={card.to} className="block h-full group" data-id="element-143">
                  <CardContent {...card} columns={columns} data-id="element-144" />
                </Link> : <div className="h-full" data-id="element-145">
                  <CardContent {...card} columns={columns} data-id="element-146" />
                </div>}
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </div>;
}
function CardContent({
  title,
  description,
  to,
  icon,
  tag,
  columns
}: CardProps & {
  columns?: number;
}) {
  const isHorizontal = columns === 3;
  return <TiltCard className="h-full" data-id="element-147">
      <SpotlightCard className={`h-full p-7 flex ${isHorizontal ? 'flex-row items-center' : 'flex-col'} gap-8 bg-picus-bg border border-picus-border relative`} data-id="element-148">
        {/* Icon */}
        <div className="flex-shrink-0 text-picus-accent" data-id="element-149">
          {icon || <Activity className="w-7 h-7" fill="currentColor" data-id="element-150" />}
        </div>

        {/* Content */}
        <div className="flex flex-col flex-grow gap-2" data-id="element-151">
          <h3 className="font-sans text-[16px] leading-[24px] uppercase tracking-[1.8px] text-white" data-id="element-152">
            {title}
          </h3>
          {description && <p className="text-picus-muted text-[16px] leading-[24px] font-mono" data-id="element-153">
              {description}
            </p>}
          {to && <div className="mt-2 flex items-center font-mono text-[12px] leading-[16px] font-medium uppercase tracking-[2.4px] text-white group-hover:text-picus-accent transition-colors" data-id="element-154">
              Learn more{' '}
              <ArrowRight className="ml-2 w-3 h-3 transform group-hover:translate-x-1 transition-transform" data-id="element-155" />
            </div>}
        </div>

        {tag && <div className="absolute top-2 right-2 border-l border-picus-accent px-1.5" data-id="element-156">
            <span className="font-mono text-[12px] font-semibold text-white uppercase tracking-[2px] block" data-id="element-157">
              {tag}
            </span>
          </div>}
      </SpotlightCard>
    </TiltCard>;
}